import { render, staticRenderFns } from "./DuplicateMediaCallBtn.vue?vue&type=template&id=c3fe2ac4&"
import script from "./DuplicateMediaCallBtn.vue?vue&type=script&lang=js&"
export * from "./DuplicateMediaCallBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports